module.exports = __webpack_public_path__ + "img/calendar-event-fill.1f82295b.svg";